import { Injectable } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { TextEditorHistoryService } from '@fi-shared/fi-text-editor/fi-text-editor-helper-services/text-editor-history.service';
import { ISelectedButtonsData } from '@fi-shared/fi-text-editor/fi-text-editor';
import { ITextPanelButton } from '@fi-shared/fi-text-panel/simple-text-panel/text-panel-base';

@Injectable()
export class AdvancedTextPanelFontStyleService {
    constructor(
        private appTextService: AppTextService,
        private textEditorHistoryService: TextEditorHistoryService,
    ) {}

    getSimpleTextFontStyleButtons(
        selectedButtonsData: ISelectedButtonsData,
        changeTextStyles: (fontStyleButton: string, showDefaultUI: boolean, valueArgument: string) => void,
    ): ITextPanelButton[] {
        return [
            {
                title: this.appTextService.get('text_editor.bold'),
                class: 'fas fa-bold',
                btnClass: 'mobile-basic BrandedColorHover panel-icon-button',
                callback: () => {
                    this.textEditorHistoryService.saveState();
                    changeTextStyles('bold', false, null);
                    this.textEditorHistoryService.restoreFocus();
                },
                selected: () => selectedButtonsData.bold,
            },
            {
                title: this.appTextService.get('text_editor.italic'),
                class: 'fas fa-italic',
                btnClass: 'mobile-basic BrandedColorHover panel-icon-button',
                callback: () => {
                    this.textEditorHistoryService.saveState();
                    changeTextStyles('italic', false, null);
                    this.textEditorHistoryService.restoreFocus();
                },
                selected: () => selectedButtonsData.italic,
            },
            {
                title: this.appTextService.get('text_editor.underline'),
                class: 'fas fa-underline',
                btnClass: 'mobile-basic BrandedColorHover panel-icon-button',
                callback: () => {
                    this.textEditorHistoryService.saveState();
                    changeTextStyles('underline', false, null);
                    this.textEditorHistoryService.restoreFocus();
                },
                selected: () => selectedButtonsData.underline,
            },
        ];
    }

    getButtons(
        selectedButtonsData: ISelectedButtonsData,
        changeTextStyles: (fontStyleButton: string, showDefaultUI: boolean, valueArgument: string) => void,
    ): ITextPanelButton[] {
        return [
            ...this.getSimpleTextFontStyleButtons(selectedButtonsData, changeTextStyles),
            {
                title: this.appTextService.get('text_editor.strike_through'),
                class: 'fas fa-strikethrough',
                btnClass: 'mobile-extended BrandedColorHover panel-icon-button',
                callback: () => {
                    this.textEditorHistoryService.saveState();
                    changeTextStyles('strikeThrough', false, null);
                    this.textEditorHistoryService.restoreFocus();
                },
                selected: () => selectedButtonsData.strikeThrough,
            },
            {
                title: this.appTextService.get('text_editor.superscript'),
                class: 'fas fa-superscript',
                btnClass: 'mobile-extended BrandedColorHover panel-icon-button',
                callback: () => {
                    this.textEditorHistoryService.saveState();
                    changeTextStyles('superscript', false, null);
                    this.textEditorHistoryService.restoreFocus();
                },
                selected: () => selectedButtonsData.superscript,
            },
            {
                title: this.appTextService.get('text_editor.subscript'),
                class: 'fas fa-subscript',
                btnClass: 'mobile-extended BrandedColorHover panel-icon-button',
                callback: () => {
                    this.textEditorHistoryService.saveState();
                    changeTextStyles('subscript', false, null);
                    this.textEditorHistoryService.restoreFocus();
                },
                selected: () => selectedButtonsData.subscript,
            },
        ];
    }
}
